import React, { useEffect, useMemo, useRef, useState } from "react";
import mainAxios from "../../../services/mainAxios";
import func, { isObjectEmpty, translateLabel } from "../../../services/functions";

import { useTranslation } from "react-i18next";
import {
  AppContext,
  getStore,
  useAppContext,
  usePersistedState,
} from "../../../AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCashRegister,
  faChevronUp,
  faCircleCheck,
  faCompress,
  faCreditCard,
  faExpand,
  faMoneyBill,
  faMoneyBillAlt,
  faQuestionCircle,
  faRedo,
  faTimesCircle,
  faTrash,
  faCartShopping,
  faUser,
  faCoins,
  faArrowLeft,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import classnames from "classnames";
import Loader from "../../Layout/Loader";
import invoiceActions from "../../../services/invoiceActions.json";
import invoiceStatuses from "../../../services/invoiceStatuses.json";
import { toast } from "react-toastify";
import PosDetails from "../../../components/MyPos/components/PosDetails";
import PopOver from "../../global/PopOver";
import Page404 from "../../Page404";
import { useLocation } from "react-router-dom";
import OpenTcrData from "../../CashRegister/OpenTcrData";
import moment from "moment";
import FinalizeInvoice from "./FinalizeInvoice";
import { Dialog } from 'primereact/dialog';
import Swal from "sweetalert2";
import InvoicePrintInfo from "../../global/InvoicePrintInfo";



const bigDecimal = require("js-big-decimal");
const { round } = func;

const EditPosTransaction = (props) => {
  const {
    user: [user],
    selectedCompany: [selectedCompany],
    company: [fullCompany],
    sideBarExpanded: [, setSideBarExpanded],
    refreshStatuses=[]
  } = useAppContext();
  const { t,i18n } = useTranslation("translations");
  const location = useLocation();
  const firstUpdate = React.useRef(true);
  const codeRef = useRef(null);

  const [refresh,setRefresh]=useState(false)
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [pageLoading, setPageLoading] = React.useState(true);
  const [persistedData, setPersistedData] = usePersistedState(
    { rate: "1", currency: "ALL" },
    "persistedData"
  );
  const [persistedStatePos, setPersistedStatePos] = usePersistedState(
    null,
    "persistedStatePos"
  );
  const [printInvoice, setPrintInvoice] = React.useState(
    location?.state?.printInvoice || false
  );
  const [searchValue, setSearchValue] = React.useState("");
  const [code, setCode] = useState("");
  const [tcrDataOperations, setTcrDataOperations] = useState([]);
  const [posState, setPosState] = React.useState(null);
  const [reloadCashDeposit, setReloadCashDeposit] = useState(false);
  const [zeroPriceItems, setZeroPriceItems] = useState({});
  const userCanDelete = [1, 2].includes(user.role.id);
  const userCanApprove = ![4, 7].includes(user.role.id);
  const [cashRegisterTcrType,setCashRegisterTcrType]=useState({ actionType:"",isOpen:false })
  const [finalizeDialogVisible, setFinalizeDialogVisible] = useState(false);
  const [finalizeDialogState, setFinalizeDialogState] = useState(null);

  // New UI state (matching Create.js design)
  const [profileDialogVisible, setProfileDialogVisible] = useState(false);
  const [customerDialogVisible, setCustomerDialogVisible] = useState(false);
  const [cartStep, setCartStep] = useState("review");
  const [mobileCartOpen, setMobileCartOpen] = useState(false);

  // Refs for mobile drawer
  const categoryTabsRef = useRef(null);
  const cartPanelRef = useRef(null);
  const dragRef = useRef({
    isDragging: false, startY: 0, startTranslateY: 0,
    currentTranslateY: 0, collapsedTranslateY: 0,
    lastY: 0, lastTime: 0, velocity: 0,
  });

  // Drag-to-scroll for category tabs (mobile horizontal mode)
  const handleCategoryMouseDown = (e) => {
    const el = categoryTabsRef.current;
    if (!el) return;
    el.dataset.dragging = "true";
    el.dataset.startX = e.pageX;
    el.dataset.scrollLeft = el.scrollLeft;
  };
  const handleCategoryMouseMove = (e) => {
    const el = categoryTabsRef.current;
    if (!el || el.dataset.dragging !== "true") return;
    e.preventDefault();
    const dx = e.pageX - parseFloat(el.dataset.startX);
    el.scrollLeft = parseFloat(el.dataset.scrollLeft) - dx;
  };
  const handleCategoryMouseUp = () => {
    const el = categoryTabsRef.current;
    if (el) el.dataset.dragging = "false";
  };

  // Auto-close mobile cart drawer when resizing
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 991) {
        setMobileCartOpen(false);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Touch drag for mobile bottom drawer
  const handleDrawerTouchStart = (e) => {
    const panel = cartPanelRef.current;
    if (!panel) return;
    const touch = e.touches[0];
    const collapsedY = panel.offsetHeight - 64;
    dragRef.current = {
      isDragging: true,
      startY: touch.clientY,
      startTranslateY: mobileCartOpen ? 0 : collapsedY,
      currentTranslateY: mobileCartOpen ? 0 : collapsedY,
      collapsedTranslateY: collapsedY,
      lastY: touch.clientY,
      lastTime: Date.now(),
      velocity: 0,
    };
    panel.style.transition = 'none';
  };

  const handleDrawerTouchMove = (e) => {
    if (!dragRef.current.isDragging) return;
    const panel = cartPanelRef.current;
    if (!panel) return;
    const touch = e.touches[0];
    const deltaY = touch.clientY - dragRef.current.startY;
    let newY = dragRef.current.startTranslateY + deltaY;
    newY = Math.max(0, Math.min(newY, dragRef.current.collapsedTranslateY));
    dragRef.current.currentTranslateY = newY;
    const now = Date.now();
    const dt = now - dragRef.current.lastTime;
    if (dt > 0) {
      dragRef.current.velocity = (touch.clientY - dragRef.current.lastY) / dt;
    }
    dragRef.current.lastY = touch.clientY;
    dragRef.current.lastTime = now;
    panel.style.transform = `translateY(${newY}px)`;
  };

  const handleDrawerTouchEnd = () => {
    if (!dragRef.current.isDragging) return;
    const panel = cartPanelRef.current;
    if (!panel) return;
    dragRef.current.isDragging = false;
    const { currentTranslateY, collapsedTranslateY, velocity } = dragRef.current;
    const threshold = collapsedTranslateY * 0.4;
    let shouldOpen;
    if (Math.abs(velocity) > 0.3) {
      shouldOpen = velocity < 0;
    } else {
      shouldOpen = currentTranslateY < threshold;
    }
    panel.style.transition = '';
    panel.style.transform = shouldOpen ? 'translateY(0)' : 'translateY(calc(100% - 64px))';
    setMobileCartOpen(shouldOpen);
    let cleaned = false;
    const cleanup = () => {
      if (cleaned) return;
      cleaned = true;
      if (panel) panel.style.transform = '';
    };
    panel.addEventListener('transitionend', cleanup, { once: true });
    setTimeout(cleanup, 500);
  };

  const currencySelectStyle = {
    control: (base) => ({
      ...base,
      minHeight: '32px',
      height: '32px',
      border: 'none',
      boxShadow: 'none',
      background: 'transparent',
      cursor: 'pointer',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 4px',
    }),
    singleValue: (base) => ({
      ...base,
      fontSize: '0.8rem',
      fontWeight: 600,
      color: '#111827',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: '32px',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: '4px',
      color: '#9ca3af',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      width: '140px',
      fontSize: '0.8rem',
      borderRadius: '8px',
      boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      zIndex: 9999,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
    option: (base, state) => ({
      ...base,
      fontSize: '0.8rem',
      padding: '0.5rem 0.75rem',
      backgroundColor: state.isSelected
        ? 'rgba(0, 117, 103, 0.08)'
        : state.isFocused
          ? '#f8f9fc'
          : 'transparent',
      color: state.isSelected ? '#007567' : '#374151',
      cursor: 'pointer',
    }),
  };

  const company = user.companiesRights.find(
    (company) => company.id === parseInt(selectedCompany)
  );
  const invoiceId = props.match.params.id;

  const fullBranchMap = useMemo(() => {
    const map = {};
    if (fullCompany?.branches) {
      for (const fb of fullCompany.branches) {
        map[fb.businUnitCode] = fb;
      }
    }
    return map;
  }, [fullCompany?.branches]);

  const branchesOptions = useMemo(() => {
    return company.branches.map((branch) => {
      const existCis = fullBranchMap[branch.businUnitCode]?.existCis ?? true;
      return {
        ...branch,
        label: branch.sellerName + " - " + branch.sellerAddress,
        value: branch.sellerName + " - " + branch.sellerAddress,
        existCis,
        inactive: !existCis
      }
    })
  }, [company?.branches, fullBranchMap])


    const tcrList = React.useMemo(() =>
    {
      let filteredBranch= company.branches.find(branch=>branch.businUnitCode==posState?.businessUnitCode)
      let tcrTypes=filteredBranch?.tcrTypes?.filter((tcrType)=>tcrType?.allowInvoice)
      let tcrList =tcrTypes?.map((tcr)=>{
        let sellerName=filteredBranch.sellerName
        return{
          label:tcr.tcrCode + "-" +sellerName ,
          value: tcr.tcrCode,
        }
      }) ?? []

      return tcrList.length>0 ?[{label:"Select",value:""}].concat(tcrList):tcrList
    },[invoiceId,posState?.businessUnitCode])

  if (!tcrList)
    tcrList = [
      {
        label: posState.tcrCode,
        value: posState.tcrCode,
      },
    ];
  const defaultCashRegisterData = {
    tcr: posState?.tcrCode,
    initialTotal: 0,
    initialAction: 0,
    withdrawTotal: 0,
    withdrawAction: 0,
    depositTotal: 0,
    depositAction: 0,
  };
  const [cashRegisterData, setCashRegisterData] = useState(
    defaultCashRegisterData
  );

  useEffect(() => {
    if (posState?.items.length > 0) {
      let zeroPrices = {};
      let newItems = posState.items.map((item) => {
        let fullItem = state.allItems.find((i) => i.code == item.code);
        const { priceWvat, priceWovat } = priceByCurrency(fullItem);
        if (priceWovat == 0) zeroPrices[item.code] = true;
        return {
          ...item,
          priceWithVat: priceWvat,
          priceWithoutVat: priceWovat,
          unitPrice: priceWovat,
        };
      });
      setZeroPriceItems(zeroPrices);
      setPosState((state) => ({
        ...state,
        items: newItems,
      }));
    }
  }, [persistedData.currency]);

  const typeOfPaymentMeansNonCash = [
    { label: t("invoice.transfer"), value: "31",btnLabel: t("invoice.transferBtn") },
    { label: t("invoice.account"), value: "42", btnLabel: t("invoice.accountBtn") },
    { label: t("invoice.other"), value: "ZZZ" , btnLabel: t("invoice.otherBtn") },
  ];

  const typeOfPaymentMeansCash = [
    { label: "BANKNOTE", value: "10" },
    { label: "BANK CARD", value: "48" },
  ];

  const paymentMethodTypes = [
    { label: "Cash", value: "cash" },
    { label: "Non Cash", value: "noncash" },
  ];

  const currenciesPos = [
    { label: "Lek", value: "ALL" },
    { label: "US Dollar", value: "USD" },
    { label: "Euro", value: "EUR" },
  ];


  const [state, setState] = React.useState(
    location?.state?.state || {
      categories: null,
      activeCategory: persistedStatePos?.activeCategory ?? null,
      allItems: null,
      filteredItems: null,
    }
  );


  React.useEffect(() => {
    mainAxios
      .post("apiEndpoint/search", {
        object: "GetCustomInvoice",
        params: {
          id: invoiceId,
        },
      })
      .then((res) => {
        if (res?.data?.status) {
          const parsedInvoice = func.parseCustomInvoiceResponse(
            res.data.content[0]
          );
          setPosState(parsedInvoice);
        }
        setPageLoading(false);
      })
      .catch(() => setPageLoading(false));
  }, [selectedCompany, props.match.params.id, refresh]);

  React.useEffect(() => {
    let allItems = location?.state?.state?.allItems;
    if (!allItems || allItems?.length == 0) {
      mainAxios
        .post("apiEndpoint/search", {
          object: "GetCompanyItems",
          value: "",
        })
        .then((res) => {
          if (res?.data?.status === true) {
            const items = res.data.content;

            const categories = items.reduce(
              (obj, item) => ({
                ...obj,
                [item.category.name]: obj[item.category.name]
                  ? obj[item.category.name] + 1
                  : 1,
              }),
              {}
            );

            setState((state) => ({
              ...state,
              allItems: items,
              filteredItems: items,
              categories,
            }));
          }
        });
    }
  }, [selectedCompany]);

  useEffect(() => {
    mainAxios
      .post("/apiEndpoint/reportOnCashDeposit", {
        object: "CashDepositRequest",
        params: {
          sendDateTime: moment().format("YYYY-MM-DD"),
          issuerNUIS: company.nuis,
        },
      })
      .then((res) => {
        setTcrDataOperations(res.data.content);
      });
  }, [reloadCashDeposit]);

  React.useEffect(() => {
    if (posState) {
      const {
        items,
        invoiceTotalWithoutVat,
        invoiceTotalVat,
        invoiceTotalWithVat,
        invoiceTotalDiscount,
        invoiceDiscountedTotalWithoutVat,
      } = func.calculateInvoiceData(posState);
      setPosState((invoice) => ({
        ...invoice,
        invoiceTotalWithoutVat,
        invoiceTotalVat,
        invoiceTotalWithVat,
        invoiceTotalDiscount,
        invoiceDiscountedTotalWithoutVat,
        items,
      }));
    }
  }, [
    ...(posState?.items
      ? posState?.items.map((item) => {
          return `${item?.quantity},${item.discountValue},${item.discountType},${item.priceWithVat}`;
        })
      : []),
    posState?.items?.length,
    posState?.discount,
  ]);

  React.useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    let filteredItems = [];
    if (searchValue.length === 0) {
      if (state.activeCategory == null) {
        filteredItems = state.allItems;
      } else if (state.activeCategory) {
        filteredItems = state.allItems.filter(
          (item) => item.category.name === state.activeCategory
        );
      }
    } else {
      filteredItems = state.allItems.filter((item) => {
        let itemName = item.name.toLowerCase();
        let searchVal = searchValue.toLowerCase();
        return (
          searchVal !== "" &&
          itemName.includes(searchVal) &&
          (item.category.name === state.activeCategory ||
            state.activeCategory === null)
        );
      });
    }
    setState((state) => ({
      ...state,
      filteredItems,
    }));
  }, [searchValue, state.activeCategory]);

  React.useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }

    if (code?.length < 4) {
      return;
    }

    const indicator = setTimeout(() => {
      state.allItems.forEach((item) => {
        if (item.code == code) {
          addRemoveItem(item);
          setCode("");
        }
      });
    }, 400);
    return () => {
      clearTimeout(indicator);
    };
  }, [code]);

  useEffect(() => {
    if (tcrDataOperations.length == 0) return;
    const result = Object.values(
      tcrDataOperations
        .filter((o) => o.tcr == posState?.tcrCode)
        .reduce((a, { tcr, ...props }) => {
          if (!a[tcr]) a[tcr] = Object.assign({}, { tcr, operations: [props] });
          else a[tcr].operations.push(props);
          return a;
        }, {})
    );
    if (result.length == 0) {
      setCashRegisterData(defaultCashRegisterData);
    }
    let initial = result[0]?.operations?.find(
      (el) => el.operation == "INITIAL"
    );
    let withdraw = result[0]?.operations?.find(
      (el) => el.operation == "WITHDRAW"
    );
    let deposit = result[0]?.operations?.find(
      (el) => el.operation == "DEPOSIT"
    );
    setCashRegisterData({
      tcr: posState?.tcrCode,
      initialTotal: initial?.total ?? 0,
      initialAction: initial?.actions ?? 0,
      depositTotal: deposit?.total ?? 0,
      depositAction: deposit?.actions ?? 0,
      withdrawTotal: withdraw?.total ?? 0,
      withdrawAction: withdraw?.actions ?? 0,
    });
  }, [posState?.tcrCode, tcrDataOperations]);

  const convertedValue = posState?.items?.reduce((sum, item) => {
    return bigDecimal.add(
      bigDecimal.add(
        round(bigDecimal.multiply(item.totalWithoutVat, posState?.rate), 2),
        round(
          bigDecimal.multiply(
            bigDecimal.multiply(item.totalWithoutVat, posState?.rate),
            bigDecimal.divide(item.vatCategory, 100)
          ),
          2
        )
      ),
      sum
    );
  }, 0);



  const approveInvoice = ({ invoiceState }) => {
    const { invoiceStartDate, invoiceEndDate } = invoiceState
    if (!invoiceEndDate && invoiceStartDate) {
     toast.error("Please complete end date", { containerId: "all_toast" });
    }
    else if (invoiceEndDate && !invoiceStartDate) {
      toast.error("Please complete Start Date", { containerId: "all_toast" });
    }else{
    setLoading(true);
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(invoiceState),
          action: invoiceActions[2],
          status: invoiceStatuses[2],
        },
        nuis: company.nuis,
      })
      .then((res) => {
        setFinalizeDialogVisible(false);
        if (res?.data?.error) {
          toast.error(res?.data?.error.errorDescription, {
            containerId: "all_toast",
          });
          setRefresh((refresh) => !refresh);
        } else if (res?.data?.status === true) {
          toast.success(t(["toast.successApprovalPOS"]), {
            containerId: "all_toast",
          });
          const parsedInvoice = func.parseCustomInvoiceResponse(
            res.data.content[0]
          );
          setPosState(parsedInvoice);
          setPersistedData((state) => ({
            ...state,
            rate: parsedInvoice.rate,
            currency: parsedInvoice.currency,
          }));
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    }
  };

    const handleRefreshStatus=()=>{
    if (!posState.invoiceTotalVat.includes("-") || posState.type === "384") {
      setLoading(true);
      mainAxios
        .post("endpoint/v2.2/saveOrUpdate", {
          object: "RefreshStatus",
          content: {
            ...func.parseCustomInvoiceRequest(posState),
            action: invoiceActions[2],
            status: invoiceStatuses[2],
          },
          nuis: company.nuis,
        })
        .then((res) => {
          if (res?.data?.error) {
            toast.error(res?.data?.error.errorDescription, {
              containerId: "all_toast",
            });
          } else {
            if (res?.data?.status === true) {
              toast.success(t(["invoice.refreshedInvoice"]), {
                containerId: "all_toast",
              });
            }
          }
          setRefresh(refresh=>!refresh)
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    } else {
      toast.warning(t(["toast.invoice.approve.warning"]), {
        containerId: "all_toast",
      });
    }
  }

  const draftInvoice = ({ invoiceState }) => {
    setLoading(true);
    const { businessUnitCode, tcrCode, ...restPersistedData } = persistedData;
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          action: invoiceActions[0],
          status: invoiceStatuses[0],
          ...func.parseCustomInvoiceRequest(invoiceState),
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(["toast.draftSaved"]), {
            containerId: "all_toast",
          });
          props.history.push({
            pathname: "/pos-transactions/edit/" + res.data.content[0].id,
            state: { state: { ...state }, printInvoice },
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

      });
  };
  const handleDelete = async () => {
    const result = await Swal.fire({
      title: t("toast.deleteDraftConfirm") || "Delete Draft?",
      text: t("toast.deleteDraftMessage") || "Are you sure you want to delete this draft? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#6b7280",
      confirmButtonText: t("common.yes") || "Yes",
      cancelButtonText: t("common.no") || "No",
    });

    if (!result.isConfirmed) {
      return;
    }

    setLoading(true);
    mainAxios
      .post("endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(posState),
          action: invoiceActions[4],
          status: invoiceStatuses[3],
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success(t(["toast.draftDeleted"]), {
            containerId: "all_toast",
          });
          props.history.push("/pos-transactions");
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleCancel = () => {
    setLoading(true);
    const correctiveInvoice = JSON.parse(JSON.stringify(posState));
    delete correctiveInvoice["id"];
    delete correctiveInvoice["invoiceHistorics"];
    delete correctiveInvoice["internalId"];
    delete correctiveInvoice["summaryInvIICRefs"];

    if (correctiveInvoice?.subSequenceDelivType != "" && correctiveInvoice?.subSequenceDelivType != null) {
      correctiveInvoice.subSequenceDelivType = "";
    }

    const opCode = user?.userCompanyOperator?.find(
      (uco) => parseInt(uco.company) === parseInt(selectedCompany)
    )?.operator ?? correctiveInvoice.opCode;

    correctiveInvoice.opCode = opCode;
    if(correctiveInvoice?.discount?.id) delete correctiveInvoice.discount.id

    correctiveInvoice.attachments = correctiveInvoice.attachments.map(
      (attachment) => {
        const { id, ...rest } = attachment;
        return rest;
      }
    );
    correctiveInvoice.items = correctiveInvoice.items.map((item) => {
      const { id, quantity, totalWithoutVat, totalWithVat, ...rest } = item;

      return {
        ...rest,
        quantity: -1 * quantity,
      };
    });

    correctiveInvoice.invoiceFees = correctiveInvoice?.invoiceFees?.map(fee => {
      const { id, ...restFee } = fee;
      return { ...restFee, feeAmount: -1 * fee.feeAmount };
    }) ?? [];

    if (correctiveInvoice?.paymentMethod?.length > 0) {
      correctiveInvoice.paymentMethod = correctiveInvoice.paymentMethod.map(payment => {
        const { paymentMethodType, paymentMeans } = posState;
        let paymentMeansValue = payment.paymentMeansValue;

        if (!paymentMeansValue) {
          const paymentOptions = paymentMethodType == "cash" ? typeOfPaymentMeansCash : typeOfPaymentMeansNonCash;
          const currentPaymentOption = paymentOptions.find(opt => opt.value === paymentMeans);
          if (currentPaymentOption?.paymentMeansValue) paymentMeansValue = currentPaymentOption.paymentMeansValue;
        }

        return {
          ...payment,
          id: null,
          paymentAmount: -1 * payment.paymentAmount,
          paymentMeansValue,
        };
      });
    }

    mainAxios
      .post("/endpoint/v2.2/saveOrUpdate", {
        object: "CustomInvoice",
        content: {
          ...func.parseCustomInvoiceRequest(correctiveInvoice),
          issueDate: new Date(),
          dueDate: new Date(),
          action: invoiceActions[0],
          status: invoiceStatuses[0],
          iic: null,
          fic: null,
          eic: null,
          opCode,
          recordDate: null,
          recordUser: null,
          number: "",
          profileId: "P10",
          type: "384",
          correctiveInv: true,
          correctiveInvType: "CORRECTIVE",
          badDebtInv: false,
          reverseCharge: false,
          selfInvoice: false,
          sumInv: false,
          cisStatus: null,
          cisError: null,
          internalId: "",
          iic_ref: correctiveInvoice.iic,
          refInvIIC: correctiveInvoice.iic,
          refInvIssueDateTime: posState?.issueDate,
        },
        nuis: company.nuis,
      })
      .then((res) => {
        if (res?.data?.status === true) {
          toast.success("Corrective POS Created!", {
            containerId: "all_toast",
          });
          props.history.push(
            "/pos-transactions/edit/" + res?.data?.content[0].id
          );
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleCategoryChange = (category) => {
    setPersistedStatePos({
      ...persistedStatePos,
      activeCategory: category ?? null,
    });
    setState((state) => ({
      ...state,
      activeCategory: category ?? null,
    }));
  };

  const handleDiscountChange = (key, value, index) => {
    const {
      unitPrice,
      discountType: dt,
      discountValue: dv,
      vatCategory: vat,
    } = posState.items[index];

    const discountType = key === "discountType" ? value : dt;
    const discountValue = key === "discountValue" ? value : dv;
    let discount;
    let isNumOrEmptyStr = /^$|^[+-]?\d+(\.\d+)?$/.test(discountValue);
    if (!isNumOrEmptyStr) return;
    let count = func.countDecimals(discountValue);
    if (discountType === "Percentage") {
      if (count > 6) {
        return;
      }
      discount = bigDecimal.multiply(
        unitPrice,
        bigDecimal.divide(discountValue, 100)
      );
    } else {
      if (count > 2) {
        return;
      }
      discount = discountValue;
    }

    const priceWithVat =
      vat == 0
        ? bigDecimal.subtract(unitPrice, discount)
        : bigDecimal.add(
            unitPrice,
            bigDecimal.multiply(unitPrice, bigDecimal.divide(vat, 100))
          );

    setPosState((posState) => ({
      ...posState,
      items: [
        ...posState.items.slice(0, index),
        {
          ...posState.items[index],
          [key]: value,
          priceWithVat: parseFloat(priceWithVat).toFixed(2),
        },
        ...posState.items.slice(index + 1),
      ],
    }));
  };

  const handlePriceWithVatChange = (e, item, index) => {
    let value = e.target.value;
    if (value.split(".")[1]) {
      value = value.split(".");
      value = value[0] + "." + value[1].slice(0, 2);
    }
    if (value.includes("-")) {
      value = value.split("-")[1] || "";
    }

    const {
      vatCategory: vat,
      discountValue,
      discountType,
    } = posState.items[index];
    const priceWithVat = new bigDecimal(value).getValue();
    const priceWithoutVat =
      vat == 0
        ? priceWithVat
        : bigDecimal.divide(
            priceWithVat,
            bigDecimal.add(1, bigDecimal.divide(vat, 100))
          );
    let discount;

    if (discountType === "Percentage") {
      discount = bigDecimal.multiply(
        bigDecimal.divide(
          priceWithoutVat,
          bigDecimal.subtract(1, bigDecimal.divide(discountValue, 100))
        ),
        bigDecimal.divide(discountValue, 100)
      );
    } else {
      discount = discountValue;
    }

    const unitPrice = bigDecimal.add(priceWithoutVat, discount);

    const updatedItems = posState.items.map((oldItem, oldIndex) =>
      oldIndex !== index
        ? oldItem
        : {
            ...item,
            unitPrice: parseFloat(unitPrice).toFixed(2),
            priceWithVat,
            priceWithoutVat: parseFloat(priceWithoutVat).toFixed(2),
          }
    );

    setPosState((posState) => ({
      ...posState,
      items: updatedItems,
    }));
  };

  const addRemoveItem = (item, quantity = "1", fixedQuantity = false) => {
    let isNumOrEmptyStr = /^$|^[+-]?\d+(\.\d+)?$/.test(quantity);
    if (
      !isNumOrEmptyStr ||
      (fixedQuantity && parseFloat(quantity) < 0) ||
      func.countDecimals(quantity) > 3
    ) {
      return;
    }
    let itemIndex = posState.items.findIndex(
      (currItem) => item.code == currItem.code
    );
    let newItem;
    if (itemIndex >= 0) {
      let item = posState.items[itemIndex];
      if (
        (!fixedQuantity &&
          (quantity == "1" ||
            (quantity == -"1" && parseFloat(item.quantity) > 1))) ||
        fixedQuantity
      ) {
        newItem = {
          ...item,
          quantity: fixedQuantity
            ? quantity
            : bigDecimal.add(item.quantity, quantity.toString()),
        };
        setPosState((posState) => ({
          ...posState,
          items: [
            ...posState.items.slice(0, itemIndex),
            newItem,
            ...posState.items.slice(itemIndex + 1),
          ],
        }));
      } else if (
        (quantity == -"1" && item.quantity == "1") ||
        quantity == "0"
      ) {
        let items = [...posState.items];
        items.splice(itemIndex, 1);
        setPosState((posState) => ({
          ...posState,
          items,
        }));
      }
    } else {
      const { priceWvat, priceWovat } = priceByCurrency(item);
      newItem = {
        code: item.code,
        description: item.vatReason,
        discountType: "Percentage",
        discountValue: "",
        investment: item.investment,
        name: item.name,
        priceWithVat: item?.priceWvatAll?.toString() ?? "0",
        priceWithoutVat: item?.priceWovatAll?.toString() ?? "0",
        quantity: "1",
        totalWithVat: item?.priceWvatAll?.toString() ?? "0",
        totalWithoutVat: item?.priceWovatAll?.toString() ?? "0",
        unitOfMeasureId: item?.unitOfMeasureId,
        unitPrice: item?.priceWovatAll?.toString() ?? "0",
        vatCategory: item.vatCategory,
        vatLabel: null,
      };
      setPosState((posState) => ({
        ...posState,
        items: [...posState.items, newItem],
      }));
      if (newItem.priceWithoutVat == 0) {
        setZeroPriceItems((state) => ({
          ...state,
          [newItem.code]: true,
        }));
      }
    }
  };

  const handleChange = (key, value) => {
    setPosState((posState) => ({
      ...posState,
      [key]: value,
    }));
  };

  const hasNoCustomer=useMemo(()=>{
    if(!posState?.parties?.buyer) return false
    const {country,id,...buyerWoCountry} = posState.parties.buyer
    return Object.values(buyerWoCountry).every(v => v === null || v === "")
  },[posState?.parties?.buyer])

  const handlePaymentMean = async (value, paymentMethodType) => {
    // Role 4 (Create) only saves drafts — skip finalization modal
    if (!userCanApprove) {
      handleChange("paymentMeans", value);
      return;
    }

    const { tcrCode, businessUnitCode } = posState

      // Check if payment method is "cash" and total invoice exceeds 500,000
      if (posState?.parties?.buyer?.buyerIDType !== "NUIS" && paymentMethodType === "cash" &&((posState.currency =="ALL" && (parseFloat(posState?.invoiceTotalWithVat) > 500000)) || (posState.currency !== "ALL" && parseFloat(posState?.invoiceTotalWithVat) > 5000) )) {
        const confirmation = await Swal.fire({
        text: t("toast.amountExceedesAlert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#007567",
        confirmButtonText: t("OK"),
        cancelButtonText: t("invoice.backToInvoice"),
      });

    if (!confirmation.isConfirmed) {
      return;
    }
  }

    const { buyerIDType, tin, town } = posState?.parties?.buyer

    if(buyerIDType && (tin == null || tin?.length==0)){
      toast.error(t("toast.buyerTinRequired",{ buyerIDType }), {
        containerId: "all_toast",
      });
      return;
    }

    if((town==null || town?.length==0) && !hasNoCustomer){
      toast.error(t("pos.cityRequired"), {
        containerId: "all_toast",
      });
      return;
    }

    if (posState.items.length == 0) {
      toast.error("You need to chose at least one item.", {
        containerId: "all_toast",
      });
      return;
    }
    if (tcrCode?.length === 0) {
      toast.error(t(["toast.tcrCode"]), {
        containerId: "all_toast",
      });
      return;
    }
    if (businessUnitCode?.length === 0) {
      toast.error(t(["toast.bussinUnitCode"]), {
        containerId: "all_toast",
      });
      return;
    }
    if (
      posState?.parties?.buyer?.buyerIDType === "NUIS" &&
      posState?.paymentMethodType === "cash" &&
      posState?.invoiceTotalWithVat > 150000
    ) {
      toast.error(t(["toast.errorPos"]), {
        containerId: "all_toast",
      });
      return;
    }

    let itemPriceValidation = true;
    posState.items.forEach((item) => {
      if (item.priceWithVat == 0) {
        itemPriceValidation = false;
        return;
      }
    });
    if (!itemPriceValidation) {
      toast.error("Item price must not be 0", {
        containerId: "all_toast",
      });
      return;
    }

    setFinalizeDialogState({ paymentMeans: value, paymentMethodType });
    setFinalizeDialogVisible(true);
    handleChange("paymentMeans", value);
  };

  const getExchangeRates = () => {
    const selectedCurrencyCode = persistedData?.currency;
    mainAxios
      .post(`api/exchange-rates/getByCode?code=${selectedCurrencyCode}`, {})
      .then((res) => {
        const data = res?.data;
        if (data) {
          setPosState((state) => ({ ...state, rate: data?.value }));
          setPersistedData({ ...persistedData, rate: data?.value });
        }
      })
      .catch((error) => {
        console.error('Error fetching exchange rate:', error);
      });
  };

  const priceByCurrency = (item) => {
    let priceWvat = item?.priceWvatAll?.toString() ?? "0";
    let priceWovat = item?.priceWovatAll?.toString() ?? "0";
    let currency = "L";
    if (persistedData.currency == "EUR") {
      priceWvat = item?.priceWvatEur?.toString() ?? "0";
      priceWovat = item?.priceWovatEur?.toString() ?? "0";
      currency = "€";
    } else if (persistedData.currency == "USD") {
      priceWvat = item?.priceWvatUsd?.toString() ?? "0";
      priceWovat = item?.priceWovatUsd?.toString() ?? "0";
      currency = "$";
    }
    return { priceWvat, priceWovat, currency };
  };
  const { allItems, filteredItems, activeCategory, categories } = state;
  const paymentMeans = posState?.paymentMeans ?? "";
  const paymentMethodType = posState?.paymentMethodType ?? "";
  let disabled = false;
  let isDraft=true
  let retryInvoice=false
  let badgeClass = "secondary";
  let statusLabel = "Draft";
  let status=posState?.status?.status
  if (posState) {

    let status = posState?.status?.status;
    let resendStatuses = refreshStatuses?.filter(resendStatus=>resendStatus?.isActive==true)?.map(resendStatus=>resendStatus?.status)?? []
    let staticRefreshConditions=posState?.einvoice && posState?.cisStatus==="SUCCESS" && (!posState?.eic || posState.eic=="")

    retryInvoice= (resendStatuses.includes(status)) || staticRefreshConditions


    disabled =
      posState?.status?.status === "APPROVED" || retryInvoice;



    if(status==="READY_FOR_APPROVAL"){
      badgeClass = "info";
      statusLabel = "Ready For Approval";
      isDraft=false
    }else if(status==="APPROVED"){
      badgeClass = "success";
      statusLabel = "Approved";
      isDraft=false
    }
  }

  const isCorrective=posState?.profileId ==="P10"

  return !pageLoading ? (
    posState ? (
      <>
      <div className={classnames("pos-terminal", { "pos-terminal--fullscreen": isFullScreen })}>

        {/* Profile & Invoice Settings Dialog */}
        <Dialog
          header={t("invoice.profileId") + " / " + t("home.branches") + " / " + t("home.tcr")}
          visible={profileDialogVisible}
          onHide={() => setProfileDialogVisible(false)}
          style={{ width: '55vw', maxWidth: '900px' }}
          breakpoints={{ '1200px': '70vw', '960px': '85vw', '641px': '95vw' }}
          modal
          baseZIndex={1300}
          className="pos-section-dialog"
        >
          {profileDialogVisible && (
            <PosDetails
              section="profile"
              posState={posState}
              setPosState={setPosState}
              persistedData={persistedData}
              setPersistedData={setPersistedData}
              branchesOptions={branchesOptions}
              tcrList={tcrList}
              disabled={disabled}
              isEditPos={true}
              hasNoCustomer={hasNoCustomer}
            />
          )}
        </Dialog>

        {/* Customer Dialog */}
        <Dialog
          header={t("navbar.customers") || "Customer"}
          visible={customerDialogVisible}
          onHide={() => setCustomerDialogVisible(false)}
          style={{ width: '55vw', maxWidth: '920px' }}
          breakpoints={{ '1200px': '70vw', '960px': '85vw', '641px': '95vw' }}
          modal
          baseZIndex={1300}
          className="pos-section-dialog"
        >
          {customerDialogVisible && (
            <PosDetails
              section="customer"
              posState={posState}
              setPosState={setPosState}
              persistedData={persistedData}
              setPersistedData={setPersistedData}
              branchesOptions={branchesOptions}
              tcrList={tcrList}
              disabled={disabled}
              isEditPos={true}
              hasNoCustomer={hasNoCustomer}
            />
          )}
        </Dialog>

        {/* Cash Register Dialog */}
        <Dialog header={cashRegisterTcrType?.actionType} visible={cashRegisterTcrType?.isOpen} style={{ width: '45vw' }} breakpoints={{ '960px': '75vw', '641px': '95vw' }} onHide={() => setCashRegisterTcrType({ isOpen: false })}>
          {cashRegisterTcrType?.isOpen && <OpenTcrData
            onClose={() => { setCashRegisterTcrType(null) }}
            onChange={() => { setReloadCashDeposit((state) => !state) }}
            data={{
              ...cashRegisterData,
              actionType: cashRegisterTcrType?.actionType,
              businUnitCode: posState?.businessUnitCode,
            }}
          />}
        </Dialog>

        {/* ── Main Two-Panel Layout ── */}
        <div className="pos-main">
          {disabled && (
            <div className="pos-print-info-wrap px-2 pt-2" style={{ flexShrink: 0 }}>
              <InvoicePrintInfo invoice={posState} preview={printInvoice} />
            </div>
          )}
          {/* ── LEFT: Items Panel ── */}
          <div className="pos-items-panel">
            {/* Command Bar — 2 Rows */}
            <div className="pos-command-bar">
              {/* Row 1: Print, E-Invoice, Status Badges, Customer, Profile, Currency, New Invoice, Fullscreen */}
              <div className="pos-command-bar__row1">
                <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="printInvoiceBar"
                    checked={printInvoice}
                    onChange={(e) => setPrintInvoice(e.target.checked)}
                  />
                  <label htmlFor="printInvoiceBar" className="custom-control-label">{t("pos.print")}</label>
                </div>
                <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="eInvoiceBar"
                    checked={posState?.einvoice || false}
                    disabled={disabled}
                    onChange={(e) => handleChange("einvoice", e.target.checked)}
                  />
                  <label htmlFor="eInvoiceBar" className="custom-control-label">{t("pos.eInvoice")}</label>
                </div>
                {!posState?.einvoice && (
                  <div className="custom-control custom-checkbox pos-command-bar__check" onClick={(e) => e.stopPropagation()}>
                    <input
                      type="checkbox"
                      className="custom-control-input"
                      id="noCustomerBar"
                      checked={hasNoCustomer}
                      disabled={disabled}
                      onChange={() => {
                        setPosState((state) => ({
                          ...state,
                          parties: {
                            ...state.parties,
                            buyer: hasNoCustomer
                              ? { tin: "99999", name: t("pos.generalCustomer"), address: " ", country: "Albania", town: " ", buyerIDType: "ID" }
                              : { tin: "", name: "", address: "", country: "Albania", town: "", buyerIDType: null },
                          },
                        }));
                      }}
                    />
                    <label htmlFor="noCustomerBar" className="custom-control-label">{t("invoice.noCustomer")}</label>
                  </div>
                )}

                {/* Status Badges */}
                {(posState?.status?.status === "APPROVED" || posState?.cisError || posState?.cisStatus) && (
                  <div className="pos-command-bar__badges">
                    {posState?.status?.status === "APPROVED" && (
                      <small className={`badge badge-${badgeClass}`} data-tooltip-id="global-tooltip" data-tooltip-content="Profisc Status">
                        {statusLabel}
                      </small>
                    )}
                    {posState.cisStatus === "SUCCESS" ? (
                      <small className="badge badge-success" data-tooltip-id="global-tooltip" data-tooltip-content="Cis Status">Success</small>
                    ) : posState.cisError ? (
                      <small
                        className="badge badge-danger d-inline-flex align-items-center"
                        data-tooltip-id="global-tooltip" data-tooltip-content={posState.cisError}
                      >
                        Error
                        <FontAwesomeIcon icon={faQuestionCircle} className="ml-1" />
                      </small>
                    ) : posState.cisStatus ? (
                      <small className="badge badge-danger">Error</small>
                    ) : null}
                    {posState?.internalPaymentStatus?.name && (
                      <small className="badge badge-info" data-tooltip-id="global-tooltip" data-tooltip-content="Payment Status">
                        {translateLabel(posState?.internalPaymentStatus?.engName, posState?.internalPaymentStatus?.albName, i18n)}
                      </small>
                    )}
                  </div>
                )}

                <button className="pos-command-bar__customer-btn" onClick={() => setCustomerDialogVisible(true)}>
                  <FontAwesomeIcon icon={faUser} className="pos-command-bar__customer-icon" />
                  <span>{posState?.parties?.buyer?.name || t("navbar.customers")}</span>
                  {posState?.einvoice && <span className="pos-command-bar__einv-badge">E-INV</span>}
                </button>
                <button
                  className="pos-command-bar__profile-btn"
                  onClick={() => setProfileDialogVisible(true)}
                  title="Profile"
                >
                  {t("pos.profileId")} - {posState?.profileId || "P1"}
                </button>
                <div className="pos-command-bar__currency">
                  <FontAwesomeIcon icon={faCoins} className="pos-command-bar__currency-icon" />
                  <Select
                    styles={currencySelectStyle}
                    options={currenciesPos}
                    value={currenciesPos.find((c) => c.value === (posState?.currency || persistedData?.currency))}
                    onChange={(option) => {
                      setPersistedData({ ...persistedData, currency: option.value, rate: "1" });
                      handleChange("currency", option.value);
                      handleChange("rate", "1");
                    }}
                    isSearchable={false}
                    isDisabled={disabled}
                    menuPortalTarget={document.body}
                    className="pos-command-bar__currency-select"
                  />
                  {(posState?.currency || persistedData?.currency) !== "ALL" && (
                    <>
                      <input
                        type="number"
                        className="pos-command-bar__rate-input"
                        value={posState?.rate}
                        step="0.01"
                        min="0"
                        disabled={disabled}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (func.countDecimals(value) > 6) return;
                          setPersistedData({ ...persistedData, rate: value });
                          handleChange("rate", value);
                        }}
                      />
                      <button className="pos-command-bar__boa-btn" onClick={getExchangeRates} disabled={disabled}>
                        GET BOA
                      </button>
                    </>
                  )}
                </div>

                {/* New Invoice button */}
                {posState?.items?.length > 0 && (
                  <button
                    className="pos-command-bar__new-invoice-btn"
                    disabled={[7].includes(user?.role?.id)}
                    onClick={() =>
                      props.history.push({
                        pathname: "/pos-transactions/create",
                        state: { state, printInvoice },
                      })
                    }
                  >
                    <FontAwesomeIcon icon={faPlus} /> {t("navbar.newInvoice") || "New Invoice"}
                  </button>
                )}

                <button
                  className="pos-command-bar__fullscreen-btn"
                  onClick={() => {
                    setIsFullScreen((fs) => {
                      if (!fs) setSideBarExpanded({ show: false, hover: false });
                      return !fs;
                    });
                  }}
                  title={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
                >
                  <FontAwesomeIcon icon={isFullScreen ? faCompress : faExpand} />
                </button>
              </div>
              {/* Row 2: Search, Scan */}
              <div className="pos-command-bar__row2">
                <input
                  id="inputID"
                  type="text"
                  className="pos-command-bar__search"
                  placeholder={t("pos.item") + "..."}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
                {!disabled && (
                  <input
                    type="text"
                    id="code"
                    name="code"
                    ref={codeRef}
                    className="pos-command-bar__scan"
                    placeholder={t("item.scanCode")}
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* Categories Sidebar + Items Grid */}
            {allItems !== null ? (
              <div className="pos-content-area">
                {/* Vertical Categories Sidebar */}
                <div
                  className={classnames("pos-categories-sidebar", { "pos-categories-sidebar--disabled": disabled })}
                  ref={categoryTabsRef}
                  onMouseDown={handleCategoryMouseDown}
                  onMouseMove={handleCategoryMouseMove}
                  onMouseUp={handleCategoryMouseUp}
                  onMouseLeave={handleCategoryMouseUp}
                >
                  <button
                    className={classnames("pos-category-item", { active: activeCategory === null })}
                    disabled={disabled}
                    onClick={() => handleCategoryChange(null)}
                  >
                    <span className="pos-category-item__name">{t("common.all") || "All"}</span>
                    <span className="pos-category-item__count">{allItems.length}</span>
                  </button>
                  {categories && Object.entries(categories).map(([category, count], index) => (
                    <button
                      key={index}
                      disabled={disabled}
                      className={classnames("pos-category-item", { active: activeCategory === category })}
                      onClick={() => handleCategoryChange(category)}
                    >
                      <span className="pos-category-item__name">{category}</span>
                      <span className="pos-category-item__count">{count}</span>
                    </button>
                  ))}
                </div>

                {/* Items Grid with Quantity Badges */}
                <div className={classnames("pos-items-grid", { "pos-items-grid--disabled": disabled })}>
                  {filteredItems && filteredItems.map((item) => {
                    let prices = priceByCurrency(item);
                    const cartItem = posState.items.find((ci) => ci.code === item.code);
                    return (
                      <div
                        key={item.id}
                        className={classnames("pos-item-card", { "pos-item-card--disabled": disabled })}
                        onClick={() => !disabled && addRemoveItem(item)}
                      >
                        {cartItem && (
                          <span key={cartItem.quantity} className="pos-item-card__qty-badge">
                            {cartItem.quantity}
                          </span>
                        )}
                        <div className="pos-item-card__name">{item.name}</div>
                        <div className="pos-item-card__price">
                          {prices.priceWvat} {prices.currency}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Loader />
              </div>
            )}
          </div>
        </div>

        {/* Mobile Cart Backdrop */}
        <div
          className={classnames("pos-cart-backdrop", { "pos-cart-backdrop--visible": mobileCartOpen })}
          onClick={() => setMobileCartOpen(false)}
        />

        {/* ── RIGHT: Cart Sidebar ── */}
        <div ref={cartPanelRef} className={classnames("pos-cart-sidebar", { "pos-cart-sidebar--open": mobileCartOpen })}>
          {/* Mobile Drawer Handle */}
          <div
            className="pos-cart-drawer-handle"
            onClick={() => setMobileCartOpen(prev => !prev)}
            onTouchStart={handleDrawerTouchStart}
            onTouchMove={handleDrawerTouchMove}
            onTouchEnd={handleDrawerTouchEnd}
          >
            <div className="pos-cart-drawer-handle__bar" />
          </div>

          {/* Cart Header */}
          <div
            className="pos-cart-sidebar__header"
            onClick={() => setMobileCartOpen(prev => !prev)}
            onTouchStart={handleDrawerTouchStart}
            onTouchMove={handleDrawerTouchMove}
            onTouchEnd={handleDrawerTouchEnd}
          >
            <div className="pos-cart-sidebar__header-top">
              <div className="pos-cart-sidebar__title">
                <FontAwesomeIcon icon={faCartShopping} />
                {t("pos.order") || "Order"}
                {posState.items.length > 0 && (
                  <span className="pos-cart-sidebar__badge">{posState.items.length}</span>
                )}
              </div>
              <div className="pos-cart-header-total">
                {func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {posState.currency}
              </div>
              <div className={classnames("pos-cart-toggle-icon", { "pos-cart-toggle-icon--open": mobileCartOpen })}>
                <FontAwesomeIcon icon={faChevronUp} />
              </div>
            </div>
            <div className="pos-cart-sidebar__ops" onClick={(e) => e.stopPropagation()}>
              <button className="pos-op-btn pos-op-btn--initial" disabled={[7].includes(user?.role?.id)} onClick={() => setCashRegisterTcrType({ actionType: "INITIAL", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.initial")}
              </button>
              <button className="pos-op-btn pos-op-btn--deposit" disabled={[7].includes(user?.role?.id)} onClick={() => setCashRegisterTcrType({ actionType: "DEPOSIT", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.deposit")}
              </button>
              <button className="pos-op-btn pos-op-btn--withdraw" disabled={[7].includes(user?.role?.id)} onClick={() => setCashRegisterTcrType({ actionType: "WITHDRAW", isOpen: true })}>
                <FontAwesomeIcon icon={faCashRegister} /> {t("pos.withdraw")}
              </button>
            </div>
          </div>

          {/* Info Strip */}
          <div className="pos-cart-sidebar__info">
            <div className="pos-cart-sidebar__info-item">
              <span>OP:</span>
              <span>{posState?.opCode}</span>
            </div>
            <div className="pos-cart-sidebar__info-item">
              <span>TCR:</span>
              <span>{posState?.tcrCode}</span>
            </div>
            <div className="pos-cart-sidebar__info-item">
              <span>{t("home.branches")}:</span>
              <span>{posState?.businessUnitCode}</span>
            </div>
          </div>

          {/* Cart Items List — only in review step */}
          {cartStep === "review" && (
            <>
              <div className="pos-cart-sidebar__items">
                {posState?.items?.length > 0 ? (
                  posState.items.map((item, index) => (
                    <div key={item.id || index} className={classnames("pos-cart-line", { "pos-cart-line--disabled": disabled })}>
                      <div className="pos-cart-line__index">{index + 1}</div>
                      <div className="pos-cart-line__body">
                        {/* Row 1: Name + Unit Price + Remove */}
                        <div className="pos-cart-line__header">
                          <div className="pos-cart-line__name">{item.name}</div>
                          <div className="pos-cart-line__unit-price">
                            {!zeroPriceItems[item?.code] ? (
                              <span>{item.quantity} x {func.formatNumber(item.priceWithVat)} {posState.currency}</span>
                            ) : (
                              <span>
                                {item.quantity} x{" "}
                                <input
                                  type="number"
                                  min="0.01"
                                  className="pos-price-input"
                                  placeholder="0.00"
                                  disabled={disabled}
                                  autoFocus={!disabled}
                                  value={item.priceWithVat}
                                  onChange={(e) => handlePriceWithVatChange(e, item, index)}
                                />
                                {" "}{posState.currency}
                              </span>
                            )}
                          </div>
                          {!disabled && (
                            <button className="pos-cart-line__remove" onClick={() => addRemoveItem(item, 0)}>
                              <FontAwesomeIcon icon={faTimesCircle} />
                            </button>
                          )}
                        </div>

                        {/* Row 2: Qty Controls | Discount | Total Price */}
                        <div className="pos-cart-line__controls">
                          <div className="pos-cart-line__qty">
                            <div className="pos-qty-group">
                              <button className="pos-qty-btn" disabled={disabled} onClick={() => addRemoveItem(item, -"1")}>-</button>
                              <input
                                type="number"
                                className="pos-qty-input"
                                value={item.quantity}
                                disabled={disabled}
                                onChange={(e) => addRemoveItem(item, e.target.value, true)}
                              />
                              <button className="pos-qty-btn" disabled={disabled} onClick={() => addRemoveItem(item, "1")}>+</button>
                            </div>
                          </div>

                          <div className="pos-cart-line__discount">
                            <div className="pos-discount-group">
                              <input
                                type="number"
                                className="pos-discount-input"
                                value={item.discountValue}
                                min={0}
                                disabled={disabled}
                                placeholder="0"
                                onKeyDown={(e) => {
                                  if (e.key === '-' || e.key === 'e') e.preventDefault();
                                }}
                                onChange={(e) => handleDiscountChange("discountValue", e.target.value, index)}
                              />
                              <button
                                className="pos-discount-toggle"
                                disabled={disabled}
                                onClick={() =>
                                  handleDiscountChange(
                                    "discountType",
                                    item.discountType === "Percentage" ? "Value" : "Percentage",
                                    index
                                  )
                                }
                              >
                                {item.discountType === "Percentage" ? "%" : posState.currency}
                              </button>
                            </div>
                          </div>

                          <div className="pos-cart-line__total">
                            <span className="pos-cart-line__price">
                              {func.formatNumber(item.totalWithVat)} {posState.currency}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="pos-cart-empty">
                    <FontAwesomeIcon icon={faCartShopping} />
                    <p>{t("pos.noItems") || "No items added yet"}</p>
                    <small>{t("pos.selectItemHint") || "Select items from the left panel"}</small>
                  </div>
                )}
              </div>

              {/* Totals */}
              <div className="pos-cart-sidebar__totals">
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalNoVat")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalWithoutVat)} {posState.currency}
                  </span>
                </div>
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalDiscount")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalDiscount)} {posState?.currency ?? 0}
                  </span>
                </div>
                <div className="pos-totals__row">
                  <span className="pos-totals__label">{t("invoice.totalVat")}</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalVat)} {posState?.currency ?? 0}
                  </span>
                </div>
                {posState.currency !== "ALL" && (
                  <div className="pos-totals__row">
                    <span className="pos-totals__label">{t("invoice.totalPay")} (LEK)</span>
                    <span className="pos-totals__value">
                      {func.getFormattedMoneyValue(convertedValue)} LEK
                    </span>
                  </div>
                )}
                <div className="pos-totals__row pos-totals__row--grand">
                  <span className="pos-totals__label">{t("invoice.totalPay")} ({posState.currency})</span>
                  <span className="pos-totals__value">
                    {func.getFormattedMoneyValue(posState?.invoiceTotalWithVat ?? 0)} {posState.currency}
                  </span>
                </div>
              </div>
            </>
          )}

          {/* Step-based Cart Footer */}
          <div className="pos-cart-sidebar__footer">
            {cartStep === "review" && (
              <div className="pos-action-row">
                {!disabled ? (
                  <button
                    className="pos-action-btn pos-action-btn--payment"
                    disabled={posState.items.length === 0}
                    onClick={() => setCartStep("payment")}
                  >
                    {t("pos.payment")} <FontAwesomeIcon icon={faArrowLeft} style={{ transform: 'rotate(180deg)' }} />
                  </button>
                ) : (
                  <>
                    {retryInvoice && (
                      <button
                        className="pos-action-btn pos-action-btn--clear"
                        style={{ background: '#f59e0b', borderColor: '#f59e0b', color: 'white' }}
                        disabled={[7].includes(user?.role?.id)}
                        onClick={() => handleRefreshStatus({ invoiceState: posState })}
                      >
                        {loading ? <Loader size="xs" color="white" /> : <><FontAwesomeIcon icon={faRedo} /> RETRY</>}
                      </button>
                    )}
                    {!retryInvoice && (
                      <button
                        className="pos-action-btn pos-action-btn--clear"
                        style={{ background: '#ef4444', borderColor: '#ef4444', color: 'white' }}
                        disabled={[7].includes(user?.role?.id) || loading}
                        onClick={handleCancel}
                      >
                        {loading ? (
                          <Loader size="xs" color="white" />
                        ) : (
                          <><FontAwesomeIcon icon={faBan} /> {t("common.cancel") || "Cancel"}</>
                        )}
                      </button>
                    )}
                  </>
                )}
              </div>
            )}
            {cartStep === "payment" && (
              <div className="pos-payment-step">
                <div className="pos-payment-step__header">
                  <button className="pos-payment-step__back" onClick={() => setCartStep("review")}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                  </button>
                  <span className="pos-payment-step__title">{t("pos.selectPayment")}</span>
                  <span className="pos-payment-step__amount">
                    {func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {posState.currency}
                  </span>
                </div>

                {/* Order Recap */}
                <div className="pos-order-recap">
                  {posState.items.map((item, index) => (
                    <div key={item.code || index} className="pos-order-recap__item">
                      <span className="pos-order-recap__qty">{item.quantity}x</span>
                      <span className="pos-order-recap__name">{item.name}</span>
                      <span className="pos-order-recap__price">{func.formatNumber(item.totalWithVat)} {posState.currency}</span>
                    </div>
                  ))}
                  <div className="pos-order-recap__total">
                    <span>{t("pos.total")}</span>
                    <span>{func.getFormattedMoneyValue(posState.invoiceTotalWithVat)} {posState.currency}</span>
                  </div>
                </div>

                {/* Payment Tiles */}
                <div className="pos-pay-grid">
                  {![4].includes(user?.role?.id) && (<>
                  <button
                    className={classnames("pos-pay-tile pos-pay-tile--banknote", {
                      "clicked": paymentMeans == typeOfPaymentMeansCash[0].value && disabled
                    })}
                    disabled={
                      ((!isCorrective && isDraft) ? paymentMethodType == "noncash" : (disabled || paymentMeans !== typeOfPaymentMeansCash[0].value)) || [7].includes(user?.role?.id) || retryInvoice
                    }
                    onClick={() => handlePaymentMean(typeOfPaymentMeansCash[0].value, "cash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faMoneyBillAlt} /></span>
                    <span className="pos-pay-tile__label">{t("pos.banknote")}</span>
                  </button>
                  <button
                    className={classnames("pos-pay-tile pos-pay-tile--card", {
                      "clicked": paymentMeans == typeOfPaymentMeansCash[1].value && disabled
                    })}
                    disabled={
                      ((!isCorrective && isDraft) ? paymentMethodType == "noncash" : (disabled || paymentMeans !== typeOfPaymentMeansCash[1].value)) || [7].includes(user?.role?.id) || retryInvoice
                    }
                    onClick={() => handlePaymentMean(typeOfPaymentMeansCash[1].value, "cash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCreditCard} /></span>
                    <span className="pos-pay-tile__label">{t("pos.bankCard")}</span>
                  </button>
                  <button
                    className={classnames("pos-pay-tile pos-pay-tile--transfer", {
                      "clicked": paymentMeans == typeOfPaymentMeansNonCash[0].value && disabled
                    })}
                    disabled={
                      ((!isCorrective && isDraft) ? retryInvoice : (disabled || paymentMeans !== typeOfPaymentMeansNonCash[0].value)) || [7].includes(user?.role?.id)
                    }
                    onClick={() => handlePaymentMean(typeOfPaymentMeansNonCash[0].value, "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faMoneyBill} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[0].btnLabel?.toUpperCase() || "TRANSFER"}</span>
                  </button>
                  <button
                    className={classnames("pos-pay-tile pos-pay-tile--account", {
                      "clicked": paymentMeans == typeOfPaymentMeansNonCash[1].value && disabled
                    })}
                    disabled={
                      ((!isCorrective && isDraft) ? retryInvoice : (disabled || paymentMeans !== typeOfPaymentMeansNonCash[1].value)) || [7].includes(user?.role?.id)
                    }
                    onClick={() => handlePaymentMean(typeOfPaymentMeansNonCash[1].value, "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCoins} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[1].btnLabel?.toUpperCase() || "ACCOUNT"}</span>
                  </button>
                  <button
                    className={classnames("pos-pay-tile pos-pay-tile--other", {
                      "clicked": paymentMeans == typeOfPaymentMeansNonCash[2].value && disabled
                    })}
                    disabled={
                      ((!isCorrective && isDraft) ? retryInvoice : (disabled || paymentMeans !== typeOfPaymentMeansNonCash[2].value)) || [7].includes(user?.role?.id)
                    }
                    onClick={() => handlePaymentMean(typeOfPaymentMeansNonCash[2].value, "noncash")}
                  >
                    <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faBan} /></span>
                    <span className="pos-pay-tile__label">{typeOfPaymentMeansNonCash[2].btnLabel?.toUpperCase() || "OTHER"}</span>
                  </button>
                  </>)}
                  {isDraft && !retryInvoice && (
                    <button
                      className="pos-pay-tile pos-pay-tile--draft"
                      disabled={[7].includes(user?.role?.id)}
                      onClick={() => draftInvoice({ invoiceState: posState })}
                    >
                      <span className="pos-pay-tile__icon"><FontAwesomeIcon icon={faCircleCheck} /></span>
                      <span className="pos-pay-tile__label">{t("pos.saveDraft") || "SAVE DRAFT"}</span>
                    </button>
                  )}
                </div>

                {/* Edit-specific action buttons */}
                <div className="pos-edit-actions">
                  {retryInvoice && (
                    <button
                      className="pos-pay-tile pos-pay-tile--retry"
                      disabled={[7].includes(user?.role?.id)}
                      onClick={() => handleRefreshStatus({ invoiceState: posState })}
                    >
                      {loading ? (
                        <Loader size="xs" color="white" />
                      ) : (
                        <>
                          <FontAwesomeIcon icon={faRedo} className="mr-1" /> RETRY
                        </>
                      )}
                    </button>
                  )}
                  {disabled && !retryInvoice && (
                    <button
                      className="pos-pay-tile pos-pay-tile--cancel"
                      disabled={[7].includes(user?.role?.id) || loading}
                      onClick={handleCancel}
                    >
                      {loading ? (
                        <Loader size="xs" color="white" />
                      ) : (
                        <><FontAwesomeIcon icon={faBan} className="mr-1" /> Cancel</>
                      )}
                    </button>
                  )}
                  {(posState?.status?.status === "DRAFT" || posState?.status?.status === "ERROR") && !retryInvoice && (
                    <button
                      className="pos-pay-tile pos-pay-tile--delete"
                      disabled={[7].includes(user?.role?.id)}
                      onClick={handleDelete}
                    >
                      <FontAwesomeIcon icon={faTrash} className="mr-1" /> {t("common.deleteDraft")}
                    </button>
                  )}
                </div>

              </div>
            )}
          </div>
        </div>

        {/* Finalize Dialog */}
        <Dialog
          visible={finalizeDialogVisible}
          onHide={() => setFinalizeDialogVisible(false)}
          className="swal-pos"
          closable={false}
          modal
          breakpoints={{ '960px': '80vw', '641px': '95vw' }}
          style={{ width: '50vw' }}
        >
          {finalizeDialogState && (
            <FinalizeInvoice
              onClose={() => setFinalizeDialogVisible(false)}
              fullCompany={fullCompany}
              approveInvoice={approveInvoice}
              posState={{ ...posState, ...finalizeDialogState }}
              isEditPos={true}
              isCorrective={isCorrective}
            />
          )}
        </Dialog>
      </div>

      </>
    ) : (
      <Page404 />
    )
  ) : (
    <Loader />
  );
};

export default EditPosTransaction;
